import { render, staticRenderFns } from "./TopicDetail.vue?vue&type=template&id=eb0bf190&scoped=true"
import script from "./TopicDetail.vue?vue&type=script&lang=js"
export * from "./TopicDetail.vue?vue&type=script&lang=js"
import style0 from "./TopicDetail.vue?vue&type=style&index=0&id=eb0bf190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0bf190",
  null
  
)

export default component.exports